import { useRef, useState, useEffect } from 'react';
import ButtonControl from "../../../Controls/ButtonControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import TextAreaControl from "../../../Controls/TextAreaControl"
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import ButtonUploadControl from "../../../Controls/ButtonUploadControl"
import SelectControl from "../../../Controls/SelectControl"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";
import {
	SetLocal,
	ClearLocal,
	GetLocal,
	FetchService,
	IsValidNationalCode,
	IsEmptyString,
	IsEmptyInput,
	GetParamsUrl,
	Base64Type
} from "../../../Base/BaseControl";

import { toast } from 'react-toastify';

let listFileType = '';
let listFile = '';
let MessageShowGeneralCommands = '';

export default function Index(props) {

	const navigate = useNavigate();
	const inpTypeRequestRef = useRef(null);
	const inpTypeDocumentRef = useRef(null);
	const inpDescriptionRef = useRef(null);

	const inpNameFamilyRef = useRef(null);
	const inpTelRef = useRef(null);
	const inpMobileRef = useRef(null);
	const inpAddressRef = useRef(null);
	const inpFileRef = useRef('');

	const [showModal, setShowModal] = useState(false);
	const [getSelectData, setSelectData] = useState([]);
	const [getValueSelectData, setValueSelectData] = useState([]);
	const [getDocumentSelectData, setDocumentSelectData] = useState([]);

	const [getShowForm, setShowForm] = useState(false);
	const [getGender, setGender] = useState(0);
	//const [getFile, setFile] = useState(false);
	//const [getFileType, setFileType] = useState(false);
	const [getdocumentEntityInfoVlueState, setdocumentEntityInfoVlueState] = useState([]);
	const [getShowGetFileStatus, setShowGetFileStatus] = useState('');

	const [getValueDocumentSelectData, setValueDocumentSelectData] = useState([]);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('OwnersSession')
		};
		FetchService("Owner/Residential/Request/GetFileStatus", inputValue, GetFileStatusSuccess, GetFileStatusFail);

		ShowRequestTypeAbstractList();
		ShowDocumentTypeAbstractList();
		ShowGeneralCommands();

		if (GetParamsUrl('InternetRequestNumber') != null)
			InternetRequestFetch();
	}, []);

	const ShowGeneralCommands = () => {
		var inputValue = {
			session: GetLocal('OwnersSession'),
			identifier: 1
		};
		FetchService("Owner/Residential/General/ShowGeneralCommands", inputValue, ShowGeneralCommandsSuccess);
	}

	const ShowGeneralCommandsSuccess = (ServiceResult) => {
		MessageShowGeneralCommands = ServiceResult.entity.replace('\n', '</br>');
	}

	const GetFileStatusSuccess = (ServiceResult) => {
		setShowForm(true);
	}

	const GetFileStatusFail = (ServiceResult) => {
		setShowForm(false);
		setShowGetFileStatus(ServiceResult);
	}

	const InternetRequestFetch = () => {
		var inputValue = {
			session: GetLocal('OwnersSession'),
			internetRequestNumber: Number(GetParamsUrl('InternetRequestNumber'))
		};
		FetchService("Owner/Residential/Request/InternetRequestFetch", inputValue, InternetRequestFetchSuccess);
	}

	const InternetRequestFetchSuccess = (ServiceResult) => {
		inpNameFamilyRef.current.value = ServiceResult.FullName;
		inpTelRef.current.value = ServiceResult.PhoneNumber;
		inpMobileRef.current.value = ServiceResult.CellNumber;
		inpAddressRef.current.value = ServiceResult.Address;
		//document.getElementById(ServiceResult.Gender).checked = true;
		setGender(ServiceResult.Gender);
		inpTypeRequestRef.current.value = ServiceResult.RequestType;
		setdocumentEntityInfoVlueState(ServiceResult.DocumentResultInfo);
		setValueSelectData(ServiceResult.RequestType);
	}

	const ShowRequestTypeAbstractList = (ServiceResult) => {
		var inputValue = {session: GetLocal('OwnersSession'),};
		FetchService("Owner/Residential/Abstract/ShowRequestTypeAbstractList", inputValue, ShowRequestTypeAbstractListSuccess);
	}

	const ShowRequestTypeAbstractListSuccess = (ServiceResult) => {
		setSelectData(ServiceResult.RequestTypeInfo);
		//data={[{id:1,title:'1'},{id:2,title:'2'},{id:3,title:'3'}]}
	}

	const ShowDocumentTypeAbstractList = (ServiceResult) => {
		var inputValue = {session: GetLocal('OwnersSession'),};
		FetchService("Owner/Residential/Abstract/ShowDocumentTypeAbstractList", inputValue, ShowDocumentTypeAbstractListSuccess);
	}

	const ShowDocumentTypeAbstractListSuccess = (ServiceResult) => {
		setDocumentSelectData(ServiceResult.DocumentTypeInfo);
	}

	const onChangeSelectControl = (value) => {
		setValueSelectData(value);
	}

	const SetTypeGender = (value) => {
		setGender(value);
	}

	const CreateInternetRequest = (event) => {
		if (IsEmptyInput(inpTypeRequestRef))
			return false;
		if (IsEmptyInput(inpNameFamilyRef))
			return false;
		if (IsEmptyInput(inpTelRef))
			return false;
		if (IsEmptyInput(inpMobileRef))
			return false;
		if (inpMobileRef.current?.value && (String(inpMobileRef.current.value)?.length !== 11)) {
			toast.error("لطفا شماره همراه را به درستی وارد کنید")
			return false;
		}
		if (IsEmptyInput(inpAddressRef))
			return false;
		//if (IsEmptyInput(inpFileRef.current.value))
		//return false;	



		var inputValue = {
			session: GetLocal('OwnersSession'),
			internetRequestNumber: Number(GetParamsUrl('InternetRequestNumber')),
			requestType: Number(getValueSelectData),
			fullName: inpNameFamilyRef.current.value,
			gender: getGender,
			phoneNumber: inpTelRef.current.value,
			cellNumber: inpMobileRef.current.value,
			address: inpAddressRef.current.value,
			documentEntityInfo: getdocumentEntityInfoVlueState
		};

		FetchService("Owner/Residential/Request/CreateInternetRequest", inputValue, CreateRequestSuccess);
	}

	const CreateRequestSuccess = (ServiceResult) => {
		toast.success("اطلاعات با موفقیت ثبت گردید");
		navigate("/SubmitRequest");
		//setShowForm(false);
	}

	const onChangeFile = (type, value) => {
		listFileType = type;
		listFile = value;
	}

	const saveDraftUpload = () => {
		if (IsEmptyInput(inpTypeDocumentRef) || IsEmptyInput(inpFileRef))
			return;

		let documentEntityInfoObject = {};
		//documentEntityInfoObject.fileNumber = 0;
		//documentEntityInfoObject.internetRequestNumber = GetParamsUrl('InternetRequestNumber') == null ? 0 : Number(GetParamsUrl('InternetRequestNumber'));
		documentEntityInfoObject.DocumentType = inpTypeDocumentRef.current.value;
		documentEntityInfoObject.Description = inpDescriptionRef.current.value;
		documentEntityInfoObject.UploadedFile = listFile;
		documentEntityInfoObject.ExtensionFile = listFileType;

		setdocumentEntityInfoVlueState([documentEntityInfoObject].concat(getdocumentEntityInfoVlueState));
		//setShowModal(false);
	}

	const DeleteFileUpload = (value) => {
		setdocumentEntityInfoVlueState(getdocumentEntityInfoVlueState.filter((item) => item.DocumentType != value.DocumentType))
	}

	const DownloadFileUpload = (value) => {
		var a = document.createElement("a");
		a.href = Base64Type(value.ExtensionFile) + value.UploadedFile;
		a.download = Math.floor(Math.random() * 10000) + "." + value.ExtensionFile;
		a.click();
		a.remove();
	}

	const ShowModal = () => {
		return (
			<Modal show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>آپلود مدارک</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<SelectControl
						data={getDocumentSelectData}
						required={true}
						title="نوع مدارک: "
						inputRef={inpTypeDocumentRef}
					/><br />
					<TextAreaControl
						title="توضیحات:"
						required={false}
						inputRef={inpDescriptionRef}
					/><br />
					<p className="text-danger" dangerouslySetInnerHTML={{ __html: MessageShowGeneralCommands }}></p>
					<ButtonUploadControl
						title="پیوست درخواست:"
						required={true}
						inputRef={inpFileRef}
						className="w-100"
						onChangeFile={onChangeFile}
						fileType={/.pdf|.ttf|.jpg|.tiff|.tif|.bmp|.jpeg/}
						accept=".pdf, .ttf, .jpg, .tiff, .tif, .bmp, .jpeg"
					/>
					<hr />
					<table className="table table-bordered">
						<tr className="bg-light">
							<th className="text-center">ردیف</th>
							<th className="text-center">نوع مدرک</th>
							<th className="text-center">توضیحات</th>
							<th className="text-center">فایل</th>
							<th className="text-center">حذف</th>
						</tr>
						{
							getdocumentEntityInfoVlueState.map((item, i) => {
								return <tr><td className="text-center">{i + 1}</td><td className="text-center">{getDocumentSelectData.filter((items) => items.ID == item.DocumentType)[0].Title}</td><td className="text-center">{item.Description}</td><td className="text-center"><i onClick={() => DownloadFileUpload(item)} class="fa fa-download" role="button"></i></td> <td className="text-center"><i onClick={() => DeleteFileUpload(item)} class="fa fa-remove text-danger" role="button"></i></td></tr>
							})
						}
					</table>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="success" onClick={saveDraftUpload}>
						افزودن
					</Button>
					<Button variant="warning" onClick={() => setShowModal(false)}>
						تایید مدارک
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}

	return (
		<div>
			{getShowForm || GetParamsUrl('InternetRequestNumber') != null ?
				<div className="p-5">
					<div className="col-sm-6">
						<SelectControl
							onChange={onChangeSelectControl}
							data={getSelectData}
							required={true}
							title="نوع درخواست: "
							inputRef={inpTypeRequestRef}
						/><br />
						<div>
							جنسیت: &nbsp;&nbsp;&nbsp;
							<input onClick={() => SetTypeGender(0)} checked={getGender === 0} type="radio" value="0" id="0" name="Gender" /> زن &nbsp;&nbsp;
							<input onClick={() => SetTypeGender(1)} checked={getGender === 1} type="radio" value="1" id="1" name="Gender" /> مرد
						</div>
						<br />
						<TextBoxControl
							title="نام و نام خانوادگی:"
							required={true}
							inputRef={inpNameFamilyRef}
						/>
					</div>
					<div className="col-sm-6">
						<TextBoxNumericControl
							title="شماره تلفن:"
							required={true}
							maxlength={11}
							inputRef={inpTelRef}
						/>
						<TextBoxNumericControl
							title="شماره همراه:"
							required={true}
							maxlength={11}
							valid="cellNumber"
							inputRef={inpMobileRef}
						/>
						<TextAreaControl
							title="نشانی متقاضی:"
							required={true}
							inputRef={inpAddressRef}
						/>
					</div>
					<br />
					<ButtonControl
						onClick={() => setShowModal(true)}
						variant="primary"
						title="آپلود مدارک"
						icon="fa fa-upload"
					/>
					<ButtonControl
						onClick={() => CreateInternetRequest()}
						variant="success"
						className="mx-4"
						title="ثبت درخواست"
						icon="fa fa-plus"
					/>
				</div>

				:
				<div>
					<br />
					<div className="alert alert-danger text-center">{getShowGetFileStatus}</div>
				</div>
			}
			<ShowModal />
		</div>
	);
}
